import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ENVIRONMENT } from 'utils/constant';
import * as Sentry from '@sentry/react';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENVIRONMENT?.toUpperCase(),
    enabled:
      process.env.REACT_APP_ENVIRONMENT === ENVIRONMENT.PRODUCTION ||
      process.env.REACT_APP_ENVIRONMENT === ENVIRONMENT.STAGING ||
      process.env.REACT_APP_ENVIRONMENT === ENVIRONMENT.STAGING_CF ||
      process.env.REACT_APP_ENVIRONMENT === ENVIRONMENT.PRODUCTION_CF,
    integrations: [
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    tracesSampleRate: 1.0,
    profilesSampleRate: 1.0,
    debug: false,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 1.0,
    maxValueLength: 10000,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const src = [ENVIRONMENT.PRODUCTION, ENVIRONMENT.PRODUCTION_CF].includes(
  process.env.REACT_APP_ENVIRONMENT || '',
)
  ? "'https://io.ecommcheckout.com/phoenix.min.js'"
  : "'https://log-stagging-scripts-894458438051.us-central1.run.app/staging/phoenix.min.js'";

const script = document.createElement('script');
script.type = 'module';
script.text = `
    !(function (e) {
      let d = document, w = window, h = d.head, s = d.createElement('script');
      s.src = ${src}; h.appendChild(s); let p;
      (p = w).addEventListener('load', () => {
        if ('phx' in p) e(p);
        else { let tnc = 0,
          iId = w.setInterval(() => {
            ('phx' in p || tnc > 20) && (clearInterval(iId), e(p)), tnc++;
          }, 500);
        }
      });
    })(function (r) { r.phx.initialize(r); });
  `;

document.head.appendChild(script);

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
